import { Container, Col, Row } from 'react-bootstrap';
import Link from 'next/link';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import translationFallback from '@/utilites/translations/translationFallback';
import BreadcrumbStructuredData from '@/components/structured_data/BreadcrumbStructuredData';
import getBasicStaticSideProps from '@/lib/staticSideProps/getBasicStaticSideProps';
import getCanonicalUrl from '@/utilites/seo/get-canonical-url';
import LanguageAlternates from '@/components/seo/LanguageAlternates';

export default function Withdrawal() {
  const { t } = useTranslation('withdrawal');
  const router = useRouter();
  const canonicalUrl = getCanonicalUrl(router);

  const title = translationFallback('policy.title', t('policy.title'), 'Right of Withdrawal');

  return (
    <>
      <Head>
        <title>{translationFallback('meta_title', t('meta_title'), 'Right of Withdrawal | Spiritory')}</title>
        <link rel="canonical" href={canonicalUrl} />
        <LanguageAlternates />
        <BreadcrumbStructuredData
          items={[
            { name: 'Home', item: 'https://spiritory.com' },
            { name: title, item: canonicalUrl },
          ]}
        />
      </Head>
      <Container className="p-5">
        <Row
          className="bg-primary text-white rounded"
          style={{ width: '60%', minWidth: 900, padding: '1.5rem 4rem', margin: '0 auto' }}
        >
          <Row>
            <Col className="d-flex justify-content-center align-items-center">
              <h1>{title}</h1>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex flex-column gap-3 mt-4">
              <p>
                {translationFallback(
                  'policy.intro',
                  t('policy.intro'),
                  'You have the right to withdraw from your contract within 14 days without giving any reason. You can declare your withdrawal conveniently online using our electronic withdrawal form — no login required.'
                )}
              </p>

              <div className="d-flex justify-content-center my-2">
                <Link
                  href="/withdrawal-form"
                  className="btn btn-light fw-bold px-4 py-2"
                  style={{ borderRadius: '0.75rem' }}
                >
                  {translationFallback('policy.cta', t('policy.cta'), 'Withdraw electronically now')}
                </Link>
              </div>

              <div className="d-flex flex-column gap-1">
                <strong style={{ fontSize: '1.5rem' }}>
                  {translationFallback('policy.right_heading', t('policy.right_heading'), 'Right of withdrawal')}
                </strong>
                <p style={{ whiteSpace: 'pre-line' }}>
                  {translationFallback('policy.right_text', t('policy.right_text'), '')}
                </p>
              </div>

              <div className="d-flex flex-column gap-1">
                <strong style={{ fontSize: '1.5rem' }}>
                  {translationFallback(
                    'policy.consequences_heading',
                    t('policy.consequences_heading'),
                    'Consequences of withdrawal'
                  )}
                </strong>
                <p style={{ whiteSpace: 'pre-line' }}>
                  {translationFallback('policy.consequences_text', t('policy.consequences_text'), '')}
                </p>
              </div>

              <div className="d-flex flex-column gap-1">
                <strong style={{ fontSize: '1.5rem' }}>
                  {translationFallback('policy.sample_heading', t('policy.sample_heading'), 'Sample withdrawal form')}
                </strong>
                <p>
                  <em>{translationFallback('policy.sample_intro', t('policy.sample_intro'), '')}</em>
                </p>
                <pre
                  className="bg-white text-dark rounded p-3"
                  style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '0.95rem' }}
                >
                  {translationFallback('policy.sample_body', t('policy.sample_body'), '')}
                </pre>
              </div>
            </Col>
          </Row>
        </Row>
      </Container>
    </>
  );
}

export const getStaticProps = getBasicStaticSideProps(['common', 'withdrawal']);
